module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.name,
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedTask == 'none'),
      expression: "selectedTask=='none'"
    }]
  }, _vm._l((_vm.tasks), function(element) {
    return _c('a', {
      staticClass: "task list-group-item",
      attrs: {
        "data-task": element.name,
        "to": '/admin/device/create/' + element.url
      },
      on: {
        "click": function($event) {
          return _vm.selectTask(element.name)
        }
      }
    }, [_c('div', {
      staticClass: "d-flex w-100 justify-content-between"
    }, [_c('p', {
      staticStyle: {
        "font-size": "15px"
      }
    }, [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('small', [_vm._v(_vm._s(element.description))])])
  }), 0), _vm._v(" "), _c('locationtag', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedTask == 'locationtag'),
      expression: "selectedTask=='locationtag'"
    }],
    ref: "locationTag"
  }), _vm._v(" "), _c('datainput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedTask == 'input'),
      expression: "selectedTask=='input'"
    }],
    ref: "input"
  }), _vm._v(" "), _c('temperature', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedTask == 'temperature'),
      expression: "selectedTask=='temperature'"
    }],
    ref: "temperature"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedTask == 'none'),
      expression: "selectedTask=='none'"
    }],
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedTask != 'none'),
      expression: "selectedTask!='none'"
    }],
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showAllTasks
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedTask != 'none'),
      expression: "selectedTask!='none'"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "data-dismiss": "modal",
      "type": "button"
    },
    on: {
      "click": _vm.addTask
    }
  }, [_vm._v("Add")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLabel"
    }
  }, [_vm._v("Select Task")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef0cb922","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/Workflows/Tasks/CreateTaskModal.vue
// module id = 668
// module chunks = 1